import { useCallback, useMemo } from 'react';
import * as Sentry from '@sentry/react';
import queryString from 'query-string';
import {
  SEARCH_ITEM_KEYS,
  KNOWN_PARAMS,
  SEARCH_PATHNAME_KEYS,
  SEARCH_PATHNAME_REGEXP,
  getUrl,
  getPathname,
  parseQueryItems,
} from 'shared/lib/jobSearchQuery';

if (!String.prototype.matchAll) {

  String.prototype.matchAll = function matchAllPolyfill(rx) {
    if (typeof rx === 'string') rx = new RegExp(rx, 'g'); // coerce a string to be a global regex
    rx = new RegExp(rx); // Clone the regex so we don't update the last index on the regex they pass us
    let cap = []; // the single capture
    const all = []; // all the captures (return this)

    while ((cap = rx.exec(this)) !== null) all.push(cap); // execute and add
    return all;
  };
  Sentry.captureMessage('matchAllPolyfill applied');
}

export default (location) => {
  const parsedSearchEntries = useMemo(() =>
    Object.entries(queryString.parse(location.search)), [location.search]);

  const isOldUrl = useMemo(() =>
    parsedSearchEntries.some(([key]) => SEARCH_PATHNAME_KEYS.includes(key)), [parsedSearchEntries]);

  const { items, params, paramsMap } = useMemo(() => {
    const matches = location.pathname.matchAll(SEARCH_PATHNAME_REGEXP);
    let parsedItems = [...matches].reduce((acc, [, key, values]) => acc.concat(
      parseQueryItems(key, values.split('+'))
    ), []);

    const parsedParams = [];

    parsedSearchEntries.forEach(([key, value]) => {
      if (SEARCH_ITEM_KEYS.includes(key)) {
        parsedItems = parsedItems.concat(parseQueryItems(key, value));
      } else if (KNOWN_PARAMS.includes(key)) {
        parsedParams.push({ key, value });
      }
    });

    return {
      items: parsedItems,
      params: parsedParams,
      paramsMap: parsedParams.reduce((acc, curr) => {
        acc[curr.key] = curr.value;
        return acc;
      }, {})
    };
  }, [location.pathname, location.search]);

  const getNewUrl = useCallback(() => {
    let parsedItems = [];
    const parsedParams = [];
    parsedSearchEntries.forEach(([key, value]) => {
      if (SEARCH_ITEM_KEYS.includes(key)) {
        parsedItems = parsedItems.concat(parseQueryItems(key, value));
      } else if (KNOWN_PARAMS.includes(key)) {
        parsedParams.push({ key, value });
      }
    });

    return getUrl(parsedItems, parsedParams, false);
  }, [parsedSearchEntries]);

  return {
    isOldUrl,
    items,
    params,
    paramsMap,
    getNewUrl,
    getUrl,
    getPathname,
  };
};
